<!--
 * @Author: 汪俊洪
 * @Date: 2021-07-12 15:44:17
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-02-27 16:03:26
 * @Description: 公共表格
-->
<template>
  <div class="column table-wrap flex-1">
    <div class="flex-1">
      <el-table
        :data="dataList"
        style="width: 100%"
        :height="tableConfig.fluidHeight ? '100%' : null"
        :max-height="tableConfig.fluidHeight ? null : tableConfig.maxHeight"
        @sort-change="sortChange"
        ref="tableList"
        v-loading="loading"
        :summary-method="tableConfig.summaryMethod"
        :show-summary="tableConfig.showSummary"
        @selection-change="handleSelectionChange"
        :row-key="tableConfig.checkBoxRowKey || null"
        @row-click="rowClick"
        @header-dragend="doLayout"
        v-bind="{ ...tableProps }"
        v-on="{ ...tableEvent }"
      >
        <el-table-column v-if="tableConfig.expand" type="expand">
          <template slot-scope="props">
            <slot name="expand" :row="props.row"></slot>
          </template>
        </el-table-column>
        <!-- 是否显示多选 -->
        <el-table-column
          v-if="showCheckBox"
          :selectable="tableConfig.checkSelectable"
          :reserve-selection="tableConfig.checkBoxRowKey ? true : false"
          type="selection"
          align="center"
          width="50"
        >
        </el-table-column>
        <!-- 显示单选 -->
        <el-table-column
          v-if="tableConfig.radioInfo"
          :label="tableConfig.radioInfo.label || '单选'"
          :width="tableConfig.radioInfo.width || '50'"
          align="center"
          @click.stop=""
        >
          <span @click.stop="" slot-scope="scope">
            <el-radio
              v-model="currentRowId"
              @change="() => rowClick(scope.row)"
              :label="scope.row[tableConfig.radioInfo.key]"
              >&nbsp;</el-radio
            >
          </span>
        </el-table-column>
        <!-- 是否显示序号 -->
        <el-table-column
          label="序号"
          v-if="tableConfig.showOrdinal"
          align="center"
          :fixed="ordinalFixed ? 'left' : null"
          width="60"
        >
          <template slot-scope="scope">{{
            input.limit * (input.page - 1) + scope.$index + 1
          }}</template>
        </el-table-column>
        <template
          v-for="(item, index) in selectedFields.length
            ? selectedFields
            : tableConfig.params"
        >
          <!-- 隐藏不显示的 -->
          <template
            v-if="
              typeof item.hideInTable === 'function'
                ? item.hideInTable(tableConfig.extra)
                : !item.hideInTable
            "
          >
            <!-- 常规的 -->
            <el-table-column
              v-if="!item.isSlot"
              :key="index"
              :prop="item.prop"
              :align="item.align || 'center'"
              :header-align="item.headerAlign || 'center'"
              :label="item.label"
              :width="item.width"
              :minWidth="item.minWidth"
              :fixed="item.fixed || null"
              :show-overflow-tooltip="item.showOverflowTooltip"
              :sortable="item.sortable ? 'custom' : null"
            >
              <template
                v-if="item.isHeaderSlot"
                :slot="item.isHeaderSlot ? 'header' : null"
                slot-scope="scope"
              >
                <slot
                  :row="scope.row"
                  :index="scope.$index"
                  :name="'header' + item.prop"
                ></slot>
              </template>
              <template slot-scope="scope">
                <!-- 显示图片 -->
                <ImageCom
                  v-if="item.valueType === 'image'"
                  style="width: 80px; height: 80px"
                  :src="scope.row[item.prop]"
                />
                <!-- 逗号分隔转多行显示 -->
                <template v-if="item.valueType === 'lineRows'">
                  <div class="lineRows" v-if="scope.row[item.prop]">
                    <div
                      v-for="(item, index) in scope.row[item.prop].split(',')"
                      :key="index"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <div v-else>-</div>
                </template>
                <!-- 字典翻译 -->
                <template v-if="item.valueType === 'dict'">
                  {{ dictFliter(scope.row[item.prop], item.options) }}
                </template>
                <!-- 默认显示文本 -->
                <template v-if="!item.valueType && !item.lineClamp">
                  <Copyable
                    v-if="item.copyable"
                    :text="scope.row[item.prop]"
                  ></Copyable>
                  <template v-if="scope.row[item.prop] !== 0">
                    {{ scope.row[item.prop] || '-' }}
                  </template>
                  <template v-else>0</template>
                </template>
                <!-- 显示多行文字 -->
                <div
                  v-if="!item.valueType && item.lineClamp"
                  :class="{ 'line-clamp': item.lineClamp }"
                  :style="[
                    {
                      '-webkit-line-clamp': item.lineClamp || ''
                    },
                    {
                      'text-align': item.align || ''
                    }
                  ]"
                >
                  <Copyable
                    v-if="item.copyable"
                    :text="scope.row[item.prop]"
                  ></Copyable>
                  {{ scope.row[item.prop] | filterMore }}
                </div>
                <!-- 显示价格 -->
                <div class="money" v-if="item.valueType === 'money'">
                  {{ scope.row[item.prop] | formatePrice }}
                </div>
                <!-- 显示价格 -->
                <div class="money" v-if="item.valueType === 'money4'">
                  {{ scope.row[item.prop] | formatePrice4 }}
                </div>
                <!-- 显示数组 -->
                <template v-if="item.valueType === 'array'">
                  {{
                    scope.row[item.prop] instanceof Array
                      ? scope.row[item.prop].join(',')
                      : scope.row[item.prop]
                  }}
                </template>
                <!-- 显示判断是否 -->
                <template v-if="item.valueType === 'whether'">
                  <span v-if="typeof scope.row[item.prop] === 'boolean'">
                    {{ scope.row[item.prop] ? '是' : '否' }}
                  </span>
                  <span v-else>
                    {{ Boolean(Number(scope.row[item.prop])) ? '是' : '否' }}
                  </span>
                </template>
              </template>
            </el-table-column>
            <!-- 自定义的 -->
            <el-table-column
              :key="item.prop"
              v-if="item.isSlot"
              :label="item.label"
              :align="item.align || 'center'"
              :header-align="item.headerAlign || 'center'"
              :width="item.width"
              :fixed="item.fixed"
              :prop="item.prop"
              :sortable="item.sortable ? 'custom' : null"
            >
              <template
                v-if="item.isHeaderSlot"
                :slot="item.isHeaderSlot ? 'header' : null"
                slot-scope="scope"
              >
                <slot
                  :row="scope.row"
                  :index="scope.$index"
                  :name="'header' + item.prop"
                ></slot>
              </template>
              <template slot-scope="scope">
                <Copyable
                  class="top-2"
                  v-if="item.copyable"
                  :text="scope.row[item.prop]"
                ></Copyable>
                <slot
                  :row="scope.row"
                  :index="scope.$index"
                  :name="item.prop"
                ></slot>
              </template>
            </el-table-column>
          </template>
        </template>
      </el-table>
    </div>
    <div class="pagination">
      <div class="flex-1">
        <Columns
          v-if="tableConfig.isCustomTable"
          :code="tableConfig.sysListCode"
          @getSelectedFields="getSelectedFields"
        />
      </div>
      <el-pagination
        v-show="tableConfig.needPagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="input.page"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="input.limit"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="count"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ImageCom from '@/components/image/index.vue'
import Copyable from '@/components/copyable/index.vue'
import Columns from '@/components/table/columns.vue'
import { scrollTo } from '@/utils/scrollTo'
import { formatePrice } from '@/utils/formatePrice'
export default {
  filters: {
    formatePrice (val) {
      if (val) {
        if (typeof val !== 'number') {
          val = val - 0
        }
        return formatePrice(val.toFixed(2))
      }
      if (val === null) {
        return '-'
      }
      return '0.00'
    },
    formatePrice4 (val) {
      if (val) {
        if (typeof val !== 'number') {
          val = val - 0
        }
        return formatePrice(val.toFixed(4))
      }
      if (val === null) {
        return '-'
      }
      return '0.0000'
    },
    filterMore (val) {
      if (val && val.length > 200) {
        val = val.substring(0, 200)
        return val
      }
      return val
    }
  },
  props: {
    tableConfig: {
      type: Object,
      default: function () {
        return {
          searchMethod: 'GET', // 接口请求方式
          autoSearch: true, // 是否需要默认查询
          needPagination: true, // 是否需要分页
          extra: {}, // 额外的参数 用于搜索
          params: []
        }
      }
    },
    tableProps: {
      type: Object,
      default: function () {
        return {}
      }
    },
    tableEvent: {
      type: Object,
      default: function () {
        return {}
      }
    },
    doSearchEvent: {
      type: Function
    }
  },
  components: {
    ImageCom,
    Copyable,
    Columns
  },
  data () {
    return {
      input: {
        page: 1, // 第几页
        limit: 20 // 一页多少条
      },
      dataList: [],
      count: 0, // 一共多少条 判断分页
      loading: false,
      multipleSelection: [], // 选择过的
      currentRowId: null,
      ordinalFixed: false, // 序号是否需要固定
      showCheckBox: false, // 判断是否需要显示多选框
      selectedFields: [], // 要显示的字段
      sortable: undefined // 表格排序信息
    }
  },
  created () {
    this.showCheckBox = this.tableConfig.showCheckBox
    if (this.tableConfig.page && this.tableConfig.page.limit) {
      this.input.limit = this.tableConfig.page.limit
    }
    // 是否自动搜索
    if (this.tableConfig.searchUrl && this.tableConfig.autoSearch) {
      const searchUse = JSON.parse(localStorage.getItem('searchUse') || '{}')
      const id = searchUse[this.sysListCode]
      console.log(id, searchUse, 'created')
      if (id) {
        return
      }
      this.getList()
    }
    this.tableConfig.params.forEach((item) => {
      if (item.fixed) {
        this.ordinalFixed = true
      }
      if (item.width === null || item.width === undefined) {
        if (item.columnsType === 'order') {
          item.width = 140
        } else if (item.columnsType === 'telephone') {
          item.width = 120
        } else if (item.columnsType === 'date') {
          item.width = 160
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.doLayout()
    }
  },
  activated () {
    this.changeTable()
  },
  methods: {
    // 字典翻译
    dictFliter (val, options = []) {
      let str = ''
      options.some((item) => {
        if (item.code === val) {
          str = item.value
          return true
        }
        return false
      })
      if (str !== '') {
        return str
      }
      return val || '-'
    },
    doLayout () {
      if (this.$refs.tableList) {
        this.$refs.tableList.doLayout()
      }
    },
    changeTable () {
      this.doLayout()
    },
    // 获取提交参数
    getParams (t, isDiff) {
      let obj = {}
      if (this.tableConfig.needPagination) {
        obj = {
          ...this.tableConfig.extra,
          ...this.input
        }
      } else {
        obj = {
          ...this.tableConfig.extra
        }
      }
      if (Object.prototype.toString.call(t) === '[object Object]') {
        obj = !isDiff
          ? {
            ...obj,
            sortable: t
          }
          : {
            ...obj,
            ...t
          }
      }
      // 如果是restful风格 参数改下
      if (this.tableConfig.searchType === 'restful') {
        obj.currentPage = obj.page
        obj.pageSize = obj.limit
        delete obj.page
        delete obj.limit
      }
      if (this.tableConfig.searchType === 'restpage') {
        obj.pageNo = obj.page
        obj.pageSize = obj.limit
        delete obj.page
        delete obj.limit
      }
      return obj
    },
    // 获取列表
    getList (t, isDiff = false) {
      return new Promise((resolve) => {
        if (t !== true) {
          this.input.page = 1
        }
        let http = this.$http.get
        let obj = {}
        if (this.tableConfig.searchMethod === 'POST') {
          http = this.$http.post
          obj = this.getParams(t, isDiff)
        } else {
          obj = {
            params: this.getParams(t, isDiff)
          }
        }
        console.log('getList',obj);
        
        this.loading = true
        http(this.tableConfig.searchUrl, obj)
          .then(({ data: res }) => {
            this.loading = false
            console.log(res.data)
            if (res.code === 0 && res.data) {
              if (this.tableConfig.resultListName === '') {
                this.dataList = res.data || []
              } else {
                this.dataList =
                  res.data[this.tableConfig.resultListName] || res.data.data
              }
              this.count = res.data[this.tableConfig.count || 'count'] - 0
            } else {
              this.dataList = []
              this.count = 0
            }
            resolve(this.dataList)
            this.tableConfig.searchCall && this.tableConfig.searchCall(res.data)
            this.$nextTick(() => {
              this.doLayout()
            }, 100)
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    // 前端分页
    setFrontPage (data) {
      this.count = data.length
      this.input.page = 1
      this.frontData = [...data]
      this.getFrontPage()
    },
    getFrontPage () {
      const start = (this.input.page - 1) * this.input.limit
      const end = this.input.page * this.input.limit
      this.dataList = this.frontData.slice(start, end) // slice() 方法不会改变原始数组
    },
    // 分页 每页多少条改变
    handleSizeChange (val) {
      this.input.page = 1
      this.input.limit = val
      // 如果是前端分页
      if (this.tableConfig.frontEndPaging) {
        this.getFrontPage()
      } else {
        this.getList()
      }
      scrollTo(0, 500)
    },
    // 分页 页码
    handleCurrentChange (val) {
      this.input.page = val
      if (this.tableConfig.frontEndPaging) {
        this.getFrontPage()
      } else {
        this.getList(true)
      }
    },
    // 设置排序
    sortChange (o) {
      const p = this.tableConfig.params.filter((i) => i.prop === o.prop)[0]
      if (p.priceSort) {
        const obj = {}
        obj[p.priceSort] = o.order ? o.order === 'descending' : ''
        console.log(obj)
        this.getList(obj, true)
        this.$emit('sortChange', [p.priceSort, obj[p.priceSort]])
        return
      }
      // desc倒序，asc正序
      let order = ''
      if (o.order === 'descending') {
        order = 'desc'
      }
      if (o.order === 'ascending') {
        order = 'asc'
      }
      if (order) {
        const sortable = {
          order,
          prop: o.prop
        }
        this.sortable = sortable
        this.getList(sortable)
        return
      }
      this.sortable = undefined
      this.getList()
    },
    // 清除排序
    clearSort () {
      this.$refs.tableList.clearSort()
    },
    // 勾选多选框
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 点击一行
    rowClick (row) {
      // 单选
      if (this.tableConfig.radioInfo) {
        const event = row[this.tableConfig.radioInfo.key]
        this.currentRowId = event
        this.$emit('checked', { row, event })
      }
      // 多选
      if (this.showCheckBox) {
        this.$refs.tableList.toggleRowSelection(row)
      }
    },
    // 获取要显示的表格数据
    getSelectedFields ({ isInit, arr = [] }) {
      const selectedFields = arr.map((item) => {
        const obj = {
          ...item,
          prop: item.code,
          align: item.fieldAlign || 'center',
          headerAlign: item.titleAlign || 'center',
          label: item.name,
          sortable: item.orderEnabled || null,
          orderNo: item.orderNo,
          width: item.width,
          minWidth: item.minWidth, // 最小宽度 string
          isSlot: item.slot, // 自定义显示 boolean
          fixed: item.fixed || null, // 固定方式 string
          showOverflowTooltip: item.showOverflowTooltip, // 超出省略
          isHeaderSlot: item.headerSlot, // boolean  头部插槽
          valueType: item.valueType, // string 值类型
          copyable: item.copyable // boolean 是否需要复制
        }
        let res = {}
        if (typeof this.tableConfig.setCustomConfig === 'function') {
          res = this.tableConfig.setCustomConfig()
        }
        // 如果有自定义方法
        if (item.renderFunc) {
          return {
            ...obj,
            ...res[item.renderFunc]
          }
        }
        return obj
      })
      this.selectedFields = selectedFields
      // 如果需要自动请求
      if (isInit) {
        return
      }
      // 是否自定义方法
      if (this.doSearchEvent) {
        this.doSearchEvent()
        return
      }
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-tooltip {
  max-width: 100%;
}

.line-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  .copyable-icon {
    top: 4px;
  }
}

.top-2 {
  top: 2px;
}

.money {
  // text-align: right;
}

.lineRows {
  text-align: left;
}

/deep/.el-radio__input {
  position: relative;
  left: 5px;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px 12px;
}

.table-wrap {
  background: #fff;
  ::v-deep .el-table th {
    background-color: #f1f5fb;
    color: #666666;
    font-family: AlibabaPuHuiTi;
    font-size: 14px;
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-pagination__sizes .el-select {
  width: auto !important;
}
</style>
